import React from 'react';
import './Manufacturingmachine.css';
import machineImg from '../../../imgs/IBMRmachine.webp';

const Manufacturingmachine = () => {
  return (
    <div className="manufacturs-container">
      <div className="manufacturs-img">
        <img src={machineImg} alt="Manufacturing Machine" className="manufactu1" />
      </div>

      <div className="manufacturs-text">
        <h2>Manufacturing Machine</h2>
        <h3>IBM200S6-R</h3>
        <ul>
          <li> Daily Yield – 19200 pcs</li>
          <li>Cycle Time – 18 second</li>
          <li> Clamping Force – 200 ton</li>
          <li>Processing Temperature – 270~300 ℃</li>
          <li> Power Consumption – 25kW/h</li>
        </ul>
        <p>
          IBM-R Series Rotary Injection Blow Molding Machine with rotary mold system for good surface finishing products like: LED bulb cover, cosmetics bottle etc.
        </p>
        <button className="learn-btn">Learn More</button>
      </div>
    </div>
  );
};

export default Manufacturingmachine;

